const SUB_DOMAINS = ['murmansk.', 'arhangelsk.', 'n-vartovsk.', 'surgut.']

export const isSubDomain = (url: string) => SUB_DOMAINS.some(domain => url.includes(domain))
